import { CircleBackslashIcon } from '@radix-ui/react-icons';
import { ElasticMatchplayMatchesMatchesInner } from '@spikemark/rest-api';
import min from 'lodash/min';
import uniq from 'lodash/uniq';
import { FC, memo } from 'react';
import { useTableContext } from '../table/table-provider';
import { ScorecardRow } from './types';
const findHoleScoreByTeam = (data: ScorecardRow[], holeIndex: number, schoolId: string, teamLabel: string = '') => min(data?.filter(x => x.schoolId === schoolId && (!x.teamLabel || x.teamLabel === teamLabel)).map(x => x.rounds?.[0].strokes?.[holeIndex]).filter(x => typeof x === 'number' && x > 0)) || null;
export const MatchplayCellHeader: FC<{
  holeIndex: number;
  match?: ElasticMatchplayMatchesMatchesInner;
}> = memo(({
  holeIndex,
  match
}) => {
  const {
    data
  } = useTableContext<ScorecardRow>();
  const holeNumber = data?.[0].holes?.[holeIndex] ?? holeIndex + 1;
  const [teamAKey, teamBKey] = uniq(match?.players?.map(x => x.schoolId + ':' + (x.teamLabel ?? '')));
  const teamA = teamAKey.split(':');
  const teamB = teamBKey.split(':');
  const teamAScore = findHoleScoreByTeam(data ?? [], holeIndex, teamA[0], teamA[1]);
  const teamBScore = findHoleScoreByTeam(data ?? [], holeIndex, teamB[0], teamB[1]);
  const score = typeof teamAScore === 'number' || typeof teamBScore === 'number' ? (teamBScore || 99) - (teamAScore || 99) : null;
  const teamColors = [teamA, teamB].map(team => {
    const [schoolId] = team;
    const color = data?.find(x => x.schoolId === schoolId)?.schoolColor;
    return color || '#000';
  });
  if (match) {
    const {
      holesLeft,
      playerDetailUp,
      scoresDetail
    } = match.players[0];
    const score = Math.abs(playerDetailUp);
    const matchIsComplete = score > holesLeft;
    if (matchIsComplete && scoresDetail[holeIndex] === null) {
      return <div className="w-7 h-7 leading-7 relative text-gray-500">
          {holeNumber}
          <CircleBackslashIcon className="absolute top-0 left-0 w-full h-full text-gray-300 opacity-80" />
        </div>;
    }
  }
  if (typeof score !== 'number') {
    return <div className="w-7 h-7 leading-7">{holeNumber}</div>;
  }
  if (score === 0) {
    return <div className="w-7 h-7 rounded-full bg-gray-200 leading-7">{holeNumber}</div>;
  }
  const color = score > 0 ? teamColors[0] : teamColors[1];
  return <div className="w-7 h-7 rounded-full bg-gray-300 leading-7 text-white" style={{
    backgroundColor: color
  }}>
      {holeNumber}
    </div>;
});